import { z } from 'zod'
import { ORDER_LINE_SPECIAL_INSTRUCTIONS_MAX } from '~/services/api/contracts/bounds/ORDER_LINE_SPECIAL_INSTRUCTIONS_MAX'
import { UpdateCartRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// A key absent from the raw input stays absent -- introducing it (even as null/undefined)
// would add a wire key callers never sent, breaking exact-body assertions downstream.
const normalize = fieldNormalizer({
  numericString: ['quantity'],
  blankToNull: ['special_instructions']
})

export const CartUpdate = (_context: NoContext) =>
  z.preprocess(
    normalize,
    UpdateCartRequestSchema.extend({
      special_instructions: z.string().max(ORDER_LINE_SPECIAL_INSTRUCTIONS_MAX).nullish()
    }).strict()
  )
